import { createSlice } from "@reduxjs/toolkit";
import { latestArticle } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const blogListSlice = createSlice({
  name: "blogList",
  initialState: data,
  reducers: {
    blogListSlice(state) {
      state.isLoading = false;
    },
    blogListSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    blogListSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    blogListSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const blogListHandler = (page:any,limit:any,category:any,search:any) => async (dispatch: any) => {
  try {
    dispatch(blogListAction.blogListSlice());
    const response: any = await latestArticle(page,limit,category,search);
    dispatch(blogListAction.blogListSliceSuccess(response));
  } catch (e: any) {
    dispatch(blogListAction.blogListSliceFailure(e?.response?.data?.message));
    dispatch(blogListAction.blogListSliceReset());
  }
};
export default blogListSlice.reducer;
export const blogListAction = blogListSlice.actions;
